// Modules
import React from 'react';

// CSS and assets
import './style.scss';

import { DEFAULT_IMAGE } from '@src/global/App/constants/constants';
import { PurchasedItemData } from './types';

interface IProps {
  itemEntity: PurchasedItemData;
  active?: boolean;
}

export const SubscriptionsBookItem: React.FC<IProps> = ({
  itemEntity: { imgUrl, navEntity, bottomContent, biiId, button },
  active = true,
}) => {
  return (
    <div className="book-item" data-biiid={biiId}>
      <div className="book-item__info-main">
        <div className="book-item__info-main-image">
          <img src={imgUrl || DEFAULT_IMAGE} alt="Wiley Book Cover" />
        </div>

        <span className="book-item__title-mobile">{navEntity.label}</span>
      </div>

      <div className="book-item__content">
        <div className="book-item__header">
          <span className="book-item__title">{navEntity.label}</span>
          {button}
        </div>

        <div className="book-item__info-wrapper">
          <div className="book-item__date">
            <span>{bottomContent.top.left}</span>
            <span>{bottomContent.bottom.left}</span>
          </div>
          {active && (
            <div className="book-item__price">
              <span>{bottomContent.top.right}</span>
              <span>{bottomContent.bottom.right}</span>
            </div>
          )}

          <div className="book-item__button-mobile">{button}</div>
        </div>
      </div>
    </div>
  );
};
